import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import '@maersk-global/mds-components-core-side-bar';
import '@maersk-global/mds-components-core-icon';
import { version } from '../../../environments/version';
import { environment } from '../../../environments/environment';
import { AuthPolicies } from '../../auth/auth-policies';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-side-menu',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SideMenuComponent {
  isWorkorderSubMenuOpen: boolean = true;
  isApprovalSubMenuOpen: boolean = false;
  isMasterDataSubMenuOpen: boolean = false;
  isApprovalWOSubMenuOpen: boolean = false;
  isReportsSubMenuOpen: boolean = false;
  isAppSupportSubMenuOpen: boolean = false;
  isScorecardSubMenuOpen: boolean = false;
  enableManualWorkOrderApproval = signal(environment.Features.EnableManulWorkOrderApproval);
  enableDmrl = signal(environment.Features.EnableDmrl);
  enableMyWorkOrder = signal(environment.Features.EnableMyWorkOrder);
  enableVSC = signal(environment.Features.EnableVSC);
  enableVSCShop = signal(environment.Features.EnableVSCShop);
  enableOperationalReports = signal(environment.Features.EnableOperationalReports);
  enableReplacedParts = signal(environment.Features.EnableReplacedParts);
  enableAIagent = signal(environment.Features.EnableAIAgent);
  enableMasterData = signal(environment.Features.EnableMasterData);
  enableImportDemandConfiguration = signal(environment.Features.EnableImportDemandConfiguration);
  enableBookingAssignment = signal(environment.Features.EnableBookingAssignment);
  enableVesselWoFileProcessing = signal(environment.Features.EnableVesselWoFileProcessing);
  enableRise = signal(environment.Features.EnableRise);
  isRiseSubMenuOpen: boolean = false;
  enableRiseImageAnalytics = signal(environment.Features.EnableRiseImageAnalytics);
  enableContainerStockView = signal(environment.Features.EnableContainerStockView);

  constructor(@Inject(AuthPolicies) public authPolicy: AuthPolicies) {}

  get appVersion(): string {
    switch (<any>environment.ENVIRONMENT) {
      case 'local':
        return 'Running Locally';
      case 'cdt':
        return version.substring(0, 7);
      case 'preprod':
        return version.substring(0, 7);
      case 'prod':
        return version;
      default:
        return 'No Version';
    }
  }
  toggleSubMenu(event: Event): void {
    this.isApprovalSubMenuOpen = (event.target as HTMLDetailsElement).open;
  }

  toggleMasterDataSubMenu(event: Event): void {
    this.isMasterDataSubMenuOpen = (event.target as HTMLDetailsElement).open;
  }

  toggleApprovalWOSubMenu(event: Event): void {
    this.isApprovalWOSubMenuOpen = (event.target as HTMLDetailsElement).open;
  }

  toggleReports(event: Event): void {
    this.isReportsSubMenuOpen = (event.target as HTMLDetailsElement).open;
  }

  toggleAppSupport(event: Event): void {
    this.isAppSupportSubMenuOpen = (event.target as HTMLDetailsElement).open;
  }

  toggleWorkorderSubMenu(event: Event): void {
    this.isWorkorderSubMenuOpen = (event.target as HTMLDetailsElement).open;
  }

  toggleScorecardSubMenu(event: Event): void {
    this.isScorecardSubMenuOpen = (event.target as HTMLDetailsElement).open;
  }

  toggleRiseSubMenu(event: Event): void {
    this.isRiseSubMenuOpen = (event.target as HTMLDetailsElement).open;
  }

  showAdvanceContainerVisibility(): boolean {
    return this.authPolicy.canViewContainerVisibility;
  }
}
